import { OnCloseType } from '../../mui/MuiModal/MuiModal';

/**
 * If a "Next up" modal is open _over_ theDropBox contract-sign-complete modal, close it
 * when the "Next up" modal is closed, as that DropBox sign modal is detached from other
 * page markup in the DOM and remains across navigation.
 *
 * We don't control that modal, so we can't close it directly, so we have to use a
 * non-react way to close it.
 */
const closeContractSignModalIfOpen = () => {
	const contractSignModal: HTMLButtonElement | null = document.querySelector(
		'.x-hellosign-embedded__modal-close-button'
	);
	if ( contractSignModal ) {
		contractSignModal.click();
	}
};

export const handleClose = ( onClose?: OnCloseType ) => () => {
	closeContractSignModalIfOpen();
	onClose?.( {}, 'fromCode' );
};
